module.exports = __webpack_public_path__ + "static/media/loading.00dea541.gif";